<template>
  <div class="wrapper">
    <!-- 1.顶部标题 -->
    <el-row>
      <h3 class="title">
        <div class="block">
          <span>智能填单</span>
        </div>
      </h3>
    </el-row>
    <el-row type="flex" class="webhfive-addbox">
      <div class="webhfive-addbox-left">
        <el-scrollbar class="scrollbar-wrap">
          <div class="webhfive-addbox-con" id="webhfive-addbox-scroll">
            <div class="webhfive-addbox-box">
              <el-form
                size="medium"
                label-width="160px"
              >
                <el-form-item label="工单名称">
                  <div class="el-form-item__content">
                    <el-input value="请输入工单名称" v-model="inputData.name" v-bind:readonly="readOnly"/>
                  </div>
                </el-form-item>
                <el-form-item label="所属应用">
                  <div class="el-form-item__content">
                    <el-input
                      value="请输入所属应用" v-model="inputData.refApp" v-bind:readonly="readOnly"
                    />
                  </div>
                </el-form-item>
                <div class="bg-gray">
                    <div v-for="(obj,index) in fiList" :key="index">
                      <div class="el-form-item form-input-d">
                        <label class="el-form-item__label">
                          <el-input
                            placeholder="自动填单项名称" v-bind:readonly="readOnly"
                            v-model="obj.name"
                          />
                        </label>
                        <div class="el-form-item__content">
                          <el-input
                            placeholder="客服话术" v-bind:readonly="readOnly"
                            v-model="obj.csSay"
                          />
                        </div>
                      </div>
                      <el-form-item label="" class="form-input-d">
                          <el-input placeholder="@实体" v-model="obj.fillRule" v-bind:readonly="readOnly"/>
                        <span class="inline-icon" v-if="!readOnly">
                            <svg class="icon" aria-hidden="true" @click="deleteFormItem(index)">
                              <use xlink:href="#icontable-delete"></use>
                            </svg>
                          </span>
                      </el-form-item>
                    </div>
                  <el-form-item label="">
                    <el-button class="btn-dashed" v-if="!readOnly" type="info" size="mini" icon="el-icon-plus" @click="addFormItem">添加填单</el-button>
                  </el-form-item>
                </div>
                <el-row type="flex" justify="center" style="margin-top: 20px">
                  <el-radio-group v-model="inputData.ruleFrom" >
                    <el-radio label="1" value="0">填单规则获取来自客户</el-radio>
                    <el-radio label="0" value="1">填单规则获取来自客服澄清话术</el-radio>
                  </el-radio-group>
                </el-row>
                <el-row type="flex" justify="center" style="margin-top: 25px;">
                  <el-button @click="goBack" style="margin-left: -40px">返回</el-button>
                  <el-button type="primary" v-if="!readOnly" @click="insertFormItem">保存设置</el-button>
                </el-row>
              </el-form>
            </div>
          </div>
        </el-scrollbar>
      </div>
      <div class="webhfive-addbox-right">
        <div class="webhfive-addbox-title">实体</div>
        <div class="webhfive-addbox-rightcon">
          <el-form inline size="small" >
            <!-- 搜索内容 -->
            <el-form-item class="form-flex" label="填单规则">
              <el-input
                class="selectInput"
                placeholder="姓名"
              >
                <svg slot="suffix" class="icon" aria-hidden="true">
                  <use xlink:href="#iconsearchicon" />
                </svg>
              </el-input>
            </el-form-item>
            <el-form-item class="text-left" size="medium">
              <el-checkbox-group v-model="checkList">
                <el-checkbox :label="0" style="width: 100%">@姓名姓名姓名姓名姓名</el-checkbox>
                <el-checkbox :label="1" style="width: 100%">@@中文姓名</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </el-row>
  </div>
</template>

<script>
import { insertForm, updateForm } from '@/api/autofillform/createAutofillform/autofillformCreate'

export default {
  name: 'autofillformCreate',
  data() {
    return {
      // acdStepIndex: 1
      checkList: [
      ],
      fiList: [],
      readOnly: false,
      inputData: {
      }
    }
  },
  props: ['transParams'],
  mounted() {
    if (this.transParams !== undefined) {
      this.inputData = this.transParams.item
      this.readOnly = this.transParams.readOnly
      if (this.inputData.formItemList !== undefined) {
        this.fiList = this.inputData.formItemList
      }
    }
  },
  methods: {
    addFormItem () {
      var model = {}
      model.name = ''
      model.csSay = ''
      model.fillRule = ''
      this.fiList.push(model)
    },
    insertFormItem () {
      // this.inputData.formItemList = this.fiList
      const params = {
        id: this.inputData.id,
        name: this.inputData.name,
        refApp: this.inputData.refApp,
        ruleFrom: this.inputData.ruleFrom,
        formItemList: this.fiList
      }
      if (this.fiList.length === 0) {
        alert('表单元素不能为空')
      } else {
        if (params.id === '') {
          insertForm(params).then(response => {
            if (response.data.code === 2000) {
              this.$emit('changeView', true)
            }
          }).catch(response => {
          })
        } else {
          updateForm(params).then(response => {
            if (response.data.code === 2000) {
              this.$emit('changeView', true)
            }
          }).catch(response => {
          })
        }
      }
    },
    deleteFormItem (index) {
      this.fiList.splice(index, 1)
    },
    goBack () {
      this.$emit('changeView', true)
    }
  }
}
</script>
<style lang="scss" scoped>
.wrapper {
  height: 100%;
}
.scrollbar-wrap {
  height: calc(100% - 61px);
}
.webhfive-addbox {
  height: calc(100% - 70px);
  margin-top: 10px;
  /*width: auto;
  height: auto;
  position: absolute;
  top: 91px;
  bottom: 0;
  left: 0px;
  right: 0;*/
  .webhfive-addbox-title {
    color: #333;
    background-color: #fff;
    border-bottom: 1px solid #ebebeb;
    padding-left: 15px;
    height: 38px;
    line-height: 38px;
    font-size: 16px;
    position: relative;
    &:before {
      content: '';
      position: absolute;
      left: 0;
      top: 12px;
      width: 3px;
      height: 14px;
      border-radius: 1px;
      background-color: #337eff;
    }
  }

  .webhfive-addbox-left {
    position: relative;
    width: 58%;
    height: 100%;
    border-right: 1px solid #e1e3e6;
    .scrollbar-wrap {
      height: calc(100% - 70px);
    }
    .webhfive-addbox-con {
      width: auto;
      /* position: absolute;
      bottom: 71px;
      top: 0;
      left: 20px;
      right: 0;*/
      /*overflow-y: auto;*/
      /*padding-bottom: 70px;*/
      .webhfive-addbox-box {
        width: 100%;
        padding-left: 20px;
        height: auto;
        margin-bottom: 20px;
        &:nth-child(1) {
          margin: 0;
        }

        ::v-deep .el-form-item {
          .el-form-item__error {
            padding-top: 2px;
          }
        }

        .webhfive-addbox-inputbox {
          margin-bottom: 15px;
          width: 100%;
          .webhfive-addbox-span {
            width: 160px;
            line-height: 36px;
            padding-left: 20px;
            font-size: 12px;
            color: #333;
          }

          .tips-wrapper {
            margin: 10px 0 0 10px;
          }
        }

        .icon-addbox {
          width: 18px;
          height: 18px;
          border: 1px solid #cfd5db;
          background-color: #f4f4f5;
          border-radius: 2px;
          text-align: center;
          cursor: pointer;
          &:hover {
            background-color: #409eff;
            border: 1px solid #409eff;
            .icon {
              color: #fff;
            }
          }

          .icon {
            color: #cfd5db;
          }
        }

        .webhfive-addbox-inline {
          width: 210px;
          display: inline-block;
          float: none;
        }

        .webhfive-addbox-center {
          align-self: center;
          margin-left: 10px;
          margin-top: 10px;
        }

        .webhfive-addbox-width {
          width: 100%;
          float: left;
          margin-top: 10px;
          &:nth-child(1) {
            margin: 0;
          }
        }

        .webhfive-addbox-width170 {
          width: 170px;
        }

        .webhfive-addbox-width390 {
          width: 390px;
        }

        .webhfive-addbox-ul {
          display: flex;
          margin-top: 5px;
          li {
            width: 26px;
            height: 26px;
            text-align: center;
            background-color: #e5e5e5;
            border-radius: 2px;
            margin-right: 10px;
            margin-bottom: 5px;
            cursor: pointer;
            border: none;
            .icon {
              vertical-align: inherit;
              font-size: 16px;
              color: #7f7f7f;
            }
            &:hover {
              background-color: #3fbeff;
              .icon {
                color: #fff;
              }
            }
            &.active {
              background-color: #3fbeff;
              .icon {
                color: #fff;
              }
            }
          }
        }
      }
    }
  }

  .webhfive-addbox-right {
    /* position: absolute;
    left: 610px;
    top: 0;
    right: 20px;*/
    width: 42%;
    border-top: 1px solid #ebebeb;
    border-right: 1px solid #ebebeb;
    .webhfive-addbox-rightcon {
      box-sizing: border-box;
      width: 100%;
      padding: 20px;
    }
  }
}
.el-form {
  /* display: flex;
  align-items: center;
  justify-content: space-between;*/

  .el-form-item {
    margin-bottom: 15px;
    ::v-deep .el-form-item__label {
      font-size: 12px;
      color: #333;
      text-align: left;
    }
    ::v-deep .el-form-item__content {
      .form-item-line {
        display: flex;
        margin-bottom: 12px;
        .el-button {
          margin-left: 10px;
        }
      }

      .el-input,
      .el-textarea,
      .el-select {
        width: 80%;
        margin-right: 10px;
        font-size: 12px;
      }
      .el-select {
        .el-input {
          width: 100%;
        }
      }

      .el-row {
        width: 80%;
        .el-input,
        .el-textarea,
        .el-select {
          width: 100%;
          margin-right: 0;
        }
      }

      .sub-title {
        margin-top: 5px;
        color: #999;
        line-height: 1.4;
      }

      .el-upload {
        margin-top: 3px;
        .el-button {
          padding: 0;
          border: 1px solid transparent;
          background-color: transparent;
          color: #337eff;
          > * {
            display: flex;
            align-items: center;

            .icon {
              font-size: 34px;
              color: #99a3ae;
            }
          }
        }
      }
      .el-upload__tip {
        margin-top: -15px;
        margin-bottom: 5px;
        color: #999;
        line-height: 1.4;
      }
    }
  }
  .form-item-complex {
    .el-row {
      width: 100% !important;
    }
    ::v-deep .el-input-number {
      .el-input-number__increase,
      .el-input-number__decrease {
        width: 20px;
        border-radius: 4px 0 0 4px;
      }
      .el-input {
        width: 100%;
        .el-input__inner {
          padding-right: 30px;
          border-radius: 4px 0 0 4px;
        }
      }
    }
    .el-button {
      font-size: 12px;
      border: 1px solid #dcdfe6;
      background-color: #f5f5f5;
      border-radius: 0 4px 4px 0;
      border-left: none;
      cursor: default;

      &:hover,
      &:active,
      &:focus {
        border-color: #dcdfe6;
        color: #333;
      }
    }
  }
  .el-button {
    & + .el-button {
      margin-left: 10px;
    }
  }
}

.bg-gray {
  background-color: #fafafa;
  border: 1px dashed #ebebeb;
  margin-left: -20px;
  margin-right: 20px;
  padding: 20px 20px 5px;
}
.btn-dashed {
  background-color: #fff;
  border: 1px dashed #ccd0d8;
  color: #68b6f3;
  &:hover,
  &:active,
  &.focus {
    border-color: #68b6f3;
  }
}
.form-flex {
  display: flex;
  margin-right: 0;
  ::v-deep .el-form-item__content {
    flex: 1;
    .selectInput {
      width: 100% !important;
    }
  }
}
.form-input-d {
  display: flex;
  align-items: center;
  .el-form-item__label {
    width: 160px;
  }
  ::v-deep .el-form-item__content,
  .el-form-item__content {
    flex: 1;
    margin-right: 10px;
    //margin-left: 160px;
    .el-input {
      width: calc(100% - 26px) !important;
    }
  }
  .inline-icon {
    cursor: pointer;
    .icon {
      color: #f66f6a;
      font-size: 16px;
    }
  }
}
</style>
